<template>
  <div class="app-container">
    <header-bar></header-bar>
    <div class="content-wrapper">
      <div class="empty-left"></div>
      <div class="left-sidenotes"></div>
      <div class="main">
        <p class="header">Terms of Service and Privacy Policy</p>
        <p>Last Updated: February 18, 2025</p>
        
        <p class="header">About Ansable VT</p>
        <p>Ansable VT ("the Website") is a personal project that simplifies access to local news. While we aim to provide a helpful service, this platform is maintained in our free time and makes no guarantees about continuous availability or future development.</p>
        
        <p class="header">1. Agreement to Terms</p>
        <p>By using Ansable VT or creating an account, you agree to these Terms of Service and Privacy Policy, including any future updates posted here. Your continued use following any changes constitutes acceptance of those changes. Ansable VT is a personal side project, not a registered business entity.</p>
        
        <p class="header">2. Service Disclaimer</p>
        <p>The Website is provided "as is" and "as available" without warranties of any kind, express or implied. We make no representations or warranties regarding the Website's availability, uptime, accuracy, or completeness of content, fitness for any particular purpose, security of your data, or uninterrupted or error-free service. We reserve the right to modify, suspend, or discontinue any part of the service at any time without notice.</p>
        
        <p class="header">3. Limitation of Liability</p>
        <p>To the maximum extent permitted by law, we disclaim all liability for any damages or losses arising from your use of the Website. You acknowledge and agree that your use of the Website is at your sole risk. We are not liable for any consequential, incidental, indirect, or special damages that may result from your use of or inability to use our services. This includes, but is not limited to, loss of data, loss of profits, or any other losses arising from your use of the service.</p>
        
        <p class="header">4. User Conduct</p>
        <p>You agree not to use the Website for any unlawful purpose or in any way that could damage, disable, overburden, or impair our service. You are responsible for all activity that occurs under your account and must notify us immediately of any unauthorized use.</p>
        
        <p class="header">5. Privacy Policy</p>
        <p><strong>5.1 Personal Information Collection</strong><br>
        We collect personal information including your name, mailing address, and email address. Additional information may be collected when you sign up for localized town and school meeting summaries, access local news headlines, become a note taker/commenter, or request customer support. We collect this information directly from you when you provide it to us voluntarily.</p>
        
        <p><strong>5.2 How We Use Your Information</strong><br>
        Your information enables us to deliver requested services, improve our offerings, communicate with you, provide customer support, send operational emails, and deliver marketing and promotional materials (with opt-out options). We process this information based on our legitimate interests in providing the services you request and improving our platform.</p>
        
        <p><strong>5.3 Data Sharing and Third Parties</strong><br>
        We may share your information with our third-party service providers who assist in operating our website, to comply with legal obligations, to protect our rights and property, or with your explicit permission. We do not collect cookies or use tracking devices, rent, sell, or share personal information for direct marketing purposes, or share your data with non-affiliated companies.</p>
        
        <p><strong>5.4 Data Security and Retention</strong><br>
        While we implement reasonable security measures to protect your information, we cannot guarantee absolute security. You acknowledge that you provide information at your own risk. We retain your data until you request deletion by emailing ansablevt@gmail.com or until it's no longer necessary for providing our services.</p>
        
        <p><strong>5.5 Third-Party Links</strong><br>
        Our website may contain links to external sites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies before providing any personal information, as our privacy policy does not extend to these third-party websites.</p>
        
        <p><strong>5.6 Your Rights</strong><br>
        You maintain the right to access your personal information, request deletion of your data, opt-out of marketing communications, and update your information. We will respond to such requests in accordance with applicable law and our operational capabilities.</p>
        
        <p><strong>5.7 Changes to This Policy</strong><br>
        We reserve the right to modify this policy at any time. We will notify users of material changes through the website. Your continued use of the Website following such changes constitutes acceptance of the updated policy.</p>
        
        <p class="header">6. Termination</p>
        <p>We reserve the right to terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we believe violates these terms or is harmful to other users, us, or third parties, or for any other reason.</p>
        
        <p class="header">7. Contact Information</p>
        <p>For privacy concerns, data requests, or any other inquiries about these terms, please contact us at ansablevt@gmail.com.</p>
        
        <p class="header">8. Severability</p>
        <p>If any provision of these terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that these terms will otherwise remain in full force and effect and enforceable.</p>
        
        <p class="header">9. Governing Law</p>
        <p>These terms shall be governed by and construed in accordance with applicable laws, without regard to conflicts of law principles. Any disputes arising from these terms or your use of the Website shall be subject to the exclusive jurisdiction of the courts in the applicable jurisdiction.</p>
      </div>
      <div class="right-sidenotes"></div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeaderBar from "./RevisedHeader.vue";
import FooterBar from "./FooterBar.vue";

export default {
  name: "TermsofService",
  components: {
    HeaderBar,
    FooterBar,
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

.app-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.content-wrapper {
  position: relative;
  flex: 1;
  display: flex;
  overflow: hidden;
  background-color: #fffff8;
  padding-top: 64px;
}

.empty-left {
  flex: 1;
  background-color: #fffff8;
}

.left-sidenotes,
.right-sidenotes {
  flex: 1;
  background-color: #fffff8;
}

.main {
  flex: 3;
  background-color: #fffff8;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.header {
  font-weight: bold;
  margin-bottom: 0rem;
  margin-top: 2rem;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

p {
  margin-bottom: 1rem;
}

/* Footer styling */
footer-bar {
  display: block;
  width: 100%;
  background-color: #545051;
  color: white;
  padding: 16px;
  text-align: center;
  font-size: 0.9rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .empty-left,
  .left-sidenotes,
  .right-sidenotes {
    display: none;
  }
  .main {
    flex: 1;
    max-width: 100%;
    padding: 0 1rem;
  }
}

@media (min-width: 1024px) {
  .empty-left,
  .left-sidenotes,
  .right-sidenotes {
    display: flex;
  }
  .main {
    flex: 3;
    max-width: 1200px;
    padding: 0;
  }
}
</style>
